import React from 'react';
import { Form, Input } from 'antd';
import { FormItem, RowWrapper } from 'component/form_component/style';
import { useSelector } from 'react-redux';

export default function Others({ formTab4, singleUserData, className, attributeForm }) {
  const { userAttributes } = useSelector((state) => state.getUsers);
  const additionalInitialValues = userAttributes.reduce((acc, field) => {
    const attribute = singleUserData?.attributes.find((attr) => attr[field] !== undefined);
    acc[field] = attribute ? attribute[field] : '';
    return acc;
  }, {});
  const renderAdditionalFields = () => {
    return userAttributes.map((field, index) => {
      if (!Array.isArray(userAttributes) || userAttributes.length === 0) {
        return null;
      }
      // Determine if the current row wrapper should have the 'oddnumber' class
      const isOdd = index % 2 === 0 && userAttributes.length % 2 !== 0 && index === userAttributes.length - 1;
      // Only render the row wrapper for even index
      if (index % 2 === 0) {
        return (
          <Form
            className={`${className}-attributes`}
            form={attributeForm}
            layout='vertical'
            initialValues={{
              ...additionalInitialValues,
            }}
          >
            <RowWrapper
              key={`row-wrapper-${index + 3}`}
              className={`${className} row-wrapper${index + 3} ${isOdd ? 'oddnumber' : ''}`}
            >
              <FormItem
                key={field}
                name={field}
                label={field}
                style={{ textTransform: 'capitalize' }}
                className={`${isOdd ? 'oddFormItem' : ''} ${className} others-form-item others-form-item_${field}`}
              >
                <Input className={`${className} others-form-input others-form-input_${field}`} />
              </FormItem>
              {userAttributes[index + 1] && (
                <FormItem
                  key={userAttributes[index + 1]}
                  name={userAttributes[index + 1]}
                  label={userAttributes[index + 1]}
                  style={{ textTransform: 'capitalize' }}
                  className={`${className} others-form-item others-form-item_${userAttributes[index + 1]}`}
                >
                  <Input className={`${className} others-form-input others-form-input_${userAttributes[index + 1]}`} />
                </FormItem>
              )}
            </RowWrapper>
          </Form>
        );
      }
      return null;
    });
  };

  return (
    <Form
      className={className}
      form={formTab4}
      layout='vertical'
      initialValues={{
        description: singleUserData?.description ? singleUserData.description : '',
        office: singleUserData?.office ? singleUserData.office : '',
        telephoneNumber: singleUserData?.telephoneNumber ? singleUserData.telephoneNumber : '',
        webPage: singleUserData?.webPage ? singleUserData.webPage : '',
      }}
    >
      <RowWrapper className={`${className} row-wrapper1`}>
        <FormItem
          key='description'
          name='description'
          label='Description'
          className={`${className} others-form-item others-form-item_description`}
        >
          <Input className={`${className} others-form-input others-form-input_description`} />
        </FormItem>

        <FormItem
          key='office'
          name='office'
          label='Office'
          className={`${className} others-form-item others-form-item_office`}
        >
          <Input className={`${className} others-form-input others-form-input_office`} />
        </FormItem>
      </RowWrapper>
      <RowWrapper className={`${className} row-wrapper2`}>
        <FormItem
          key='telephoneNumber'
          name='telephoneNumber'
          label='Telephone Number'
          className={`${className} others-form-item others-form-item_telephone_no`}
        >
          <Input className={`${className} others-form-input others-form-input_telephone_no`} />
        </FormItem>
        <FormItem
          key='webPage'
          name='webPage'
          label='Web Page'
          className={`${className} others-form-item others-form-item_webpage`}
        >
          <Input className={`${className} others-form-input others-form-input_webpage`} />
        </FormItem>
      </RowWrapper>
      {localStorage.getItem('role') !== 'user' && renderAdditionalFields()}
    </Form>
  );
}
